var render = function render(){var _vm=this,_c=_vm._self._c;return _c('spreadsheet',{attrs:{"opts":_vm.user_opts}})
}
var staticRenderFns = []

export { render, staticRenderFns }